import React, {useEffect, useState} from 'react';
import Cookies from 'js-cookie';
import api from "../../../api/axios.js";

const FutureProjectChart = () => {
    const [projectData, setProjectData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [bauleiterFilter, setBauleiterFilter] = useState('');


    useEffect(() => {
        const fetchData = async () => {
            try {
                const accessToken = Cookies.get('accessToken');
                if (!accessToken) {
                    throw new Error('Access Token fehlt.');
                }

                const response = await api.get('/api/v1/projects/future', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                });
                const formattedData = response.data.map((project) => {
                    const number = project?.number ?? 'Unbekannt';
                    const subject = project?.subject ?? 'Kein Titel';
                    const state = project?.state ?? 'Unbekannter Status';
                    const bauleiter = project?.siteManager?.forename && project?.siteManager?.surname
                        ? `${project.siteManager.forename} ${project.siteManager.surname}`
                        : 'Nicht zugewiesen';

                    return {number, subject, state, bauleiter};
                });

                setProjectData(formattedData);
                setLoading(false);
            } catch (error) {
                console.error('Fehler beim Abrufen der Daten:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>Lade Daten...</div>;
    }

    const truncate = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    const filteredData = projectData.filter(project =>
        project.bauleiter.toLowerCase().includes(bauleiterFilter.toLowerCase())
    );


    return (
        <div className="w-full flex flex-col justify-start pt-2 text-sm">
            <input
                type="text"
                placeholder="Bauleiter filtern..."
                className="border rounded px-2 py-1 mb-2 w-full max-w-xs"
                value={bauleiterFilter}
                onChange={(e) => setBauleiterFilter(e.target.value)}
            />
            <div className={"overflow-x-auto overflow-y-auto max-h-[800px]"}>
                <table className="min-w-full table-auto border-collapse mt-4">
                    <thead className={"mt-4"}>
                    <tr>
                        <th className="cursor-pointer text-left px-2">Projekt-ID</th>
                        <th className="cursor-pointer text-left px-2">Projekt</th>
                        <th className="cursor-pointer text-left px-2">Status</th>
                        <th className="cursor-pointer text-left px-2">Bauleiter</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredData.map((project, index) => (
                        <tr
                            key={index}
                            className={`border-t hover:bg-gray-100`}
                            style={{cursor: 'pointer'}}
                        >
                            <td className="text-left px-2 py-1">{project.number}</td>
                            <td className="text-left px-2 py-1">{truncate(project.subject, 70)}</td>
                            <td className="text-left px-2">{project.state}</td>
                            <td className="text-left px-2">{project.bauleiter}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FutureProjectChart;
